import { interviewSimulationsDetailsTranslation } from '@/assets/locales/views/interviewSimulations/details/interviewSimulationsDetails.translation.pl.ts';
import { InterviewSimulationsTranslation } from '@/assets/locales/views/interviewSimulations/interviewSimulations.translation.en.ts';

export const interviewSimulationsTranslation: InterviewSimulationsTranslation = {
  details: interviewSimulationsDetailsTranslation,
};
